<template lang="pug">
  v-main#complete
    v-card(v-if="loading")
      v-card-text
        i.fas.fa-spin.fa-spinner
    v-card(v-else)
      v-card-text 
        b {{ status == -1 || status == 0 ? 'Payment unsuccessful' : 'Payment successful' }}
      v-card-text 
        em {{ description }}
    v-card(v-if="promo_redeemed")
      v-card-text Promotion successfully redeemed!
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

//to add promo redeem api here
export default {
  data() {
    return {
      promo_redeemed: false,
      loading: true,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    status() {
      return this.$route.query.status;
    },
    description() {
      return this.$route.query.desc;
    },
    orderId() {
      return this.$route.query.o;
    },
    suborderId() {
      return this.$route.query.id;
    }
  },
  mounted() {
    if (this.status > 0) this.redeemPromo();
  },
  methods: {
    redeemPromo() {
      let url = config.redeemPromoUrl();

      var json = {
        customer_id: this.$store.getters.customerId,
        customer_sessiontoken: this.$store.getters.sessionToken,
        order_id: this.orderId
      };

      console.log(json);

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.promo_redeemed = true;
              } else {
                this.$swal(
                  this.$t("error.promotion_redeem"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.promotion_redeem"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.promotion_redeem"),
            response.body.message,
            "error"
          );
        });
    }
    // payment() {
    //   let url = config.paymentUrl();

    //   var json = {
    //     test: true,
    //     suborder_id: this.suborderId,
    //     // transaction_type: "online",
    //     customer_id: this.$store.getters.customerId,
    //     customer_sessiontoken: this.$store.getters.sessionToken
    //   };

    //   console.log(json);

    //   this.loading = true;

    //   this.$http
    //     .post(url, json)
    //     .then(function(response) {
    //       // Success
    //       try {
    //         if (response) {
    //           this.loading = false;

    //           if (!this.$helpers.handleResponse(response.body.message)) return;

    //           this.feedback.success =
    //             response.body.data ||
    //             this.$helpers.handleResponse(response.body.message)
    //               ? true
    //               : false;

    //           if (this.feedback.success) {
    //             this.redeemPromo();
    //           } else {
    //             this.$swal(
    //               this.$t("error.payment_complete"),
    //               response.body.message,
    //               "error"
    //             );
    //           }
    //         }
    //       } catch (error) {
    //         this.feedback.success = false;
    //         this.$swal(
    //           this.$t("error.payment_complete"),
    //           response.body.message,
    //           "error"
    //         );
    //       }
    //     })
    //     .catch(response => {
    //       this.feedback.success = false;
    //       this.$swal(
    //         this.$t("error.payment_complete"),
    //         response.body.message,
    //         "error"
    //       );
    //     });
    // }
  }
};
</script>
